import PropTypes from "prop-types";
import cn from "classnames";
import styles from "solar/components/Anchor.module.scss";

export default function Anchor({ id, offset = false }) {
  return (
    <div id={id} className={cn(styles.component, offset && styles.offset)} />
  );
}

Anchor.propTypes = {
  id: PropTypes.string.isRequired,
  offset: PropTypes.bool,
};
